import { Trans, useTranslation } from "react-i18next";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";

export function FaqSection() {
  const { t } = useTranslation(["newLanding"]);
  const items = Array.from({ length: 10 }, (_, i) => {
    const index = i + 1;
    return {
      q: t(`faq.q${index}`),
      a: t(`faq.a${index}`),
      index,
    };
  });

  return (
    <section
      id="faq"
      className="flex flex-col items-center w-full px-4 py-10 sm:py-14 md:py-16 bg-background scroll-mt-24 md:scroll-mt-28"
    >
      <h2 className="mb-6 text-2xl font-semibold tracking-tight text-center sm:text-3xl md:text-4xl">
        {t("faq.title")}
      </h2>
      <p className="mb-6 text-center text-muted-foreground">
        {t("faq.subtitle")}
      </p>
      <div className="w-full max-w-3xl border divide-y rounded-lg bg-card">
        {items.map(({ q, a, index }) => (
          <Collapsible key={index}>
            <CollapsibleTrigger asChild>
              <button className="flex items-center justify-between w-full p-4 text-left hover:bg-muted/40 focus:outline-none">
                <span className="font-medium">{q}</span>
                <span className="ml-4 text-muted-foreground">+</span>
              </button>
            </CollapsibleTrigger>
            <CollapsibleContent className="px-4 py-4 text-sm text-muted-foreground">
              <p className="whitespace-pre-line">
                <Trans
                  ns="newLanding"
                  i18nKey={`faq.a${index}`}
                  components={{
                    strong: <strong />,
                    em: <em />,
                    u: <u />,
                    code: (
                      <code className="px-1 py-0.5 rounded bg-muted text-foreground" />
                    ),
                    br: <br />,
                  }}
                >
                  {a}
                </Trans>
              </p>
            </CollapsibleContent>
          </Collapsible>
        ))}
      </div>
    </section>
  );
}
